<template>
    <div>
        <!-- Contenido principal -->
        <!-- <main class="layoutContent"> -->
            <!-- Encabezado contenido principal -->
            <div class="page-header container pt-2">
                <!-- <div class="container pt-2"> -->
                    <div class="row align-items-center justify-content-between">
                        <div class="col-auto pt-1">
                            <h1 class="page-header--title">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                    class="bi bi-bookmark-heart" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M8 4.41c1.387-1.425 4.854 1.07 0 4.277C3.146 5.48 6.613 2.986 8 4.412z" />
                                    <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
                                </svg>
                                Reservas
                            </h1>
                            <div class="custom-control custom-checkbox pb-3">
                                <!-- <span class="text-white">Temporada</span> -->
                                <b-form-select v-model="cbAno" value-field="id" text-field="id"
                                    @change="filtroReservas"
                                    :options="itemsAno"
                                    class="mb-0 form-control"
                                ></b-form-select>
                            </div>
                        </div>
                    <!-- </div> -->
                </div>
            </div>
            <!-- Fin encabezado contenido principal -->

            <!-- RESERVAS -->
            <div class="container content-body">
                <div class="row">
                    <div class="col-12 h-100">
                        <div class="row card mb-2">
                            <!-- <div class="card-header d-flex flex-column flex-sm-row align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" fill="currentColor"
                                    class="bi bi-journal-bookmark" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M6 8V1h1v6.117L8.743 6.07a.5.5 0 0 1 .514 0L11 7.117V1h1v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z" />
                                    <path
                                        d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
                                    <path
                                        d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
                                </svg>
                                Temporada
                            </div> -->
                            <div class="col-12 card-body">
                                <!-- {{ itemsRes }} -->
                                <div v-if="filterRes.length==0">
                                    <h3>No hay Reservas</h3>
                                </div>
                                <div v-else class="card card-booking mb-2" v-for="item in filterRes" :key="item.id">
                                    <reserva :R="item" @actualiza="leemos"/>
                                </div>
                            </div>
                            <div class="card-footer">
                                <p class="pl-2">**</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </main>         -->
    </div>

</template>

<script>


import reserva from '@/components/reserva.vue'

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'reservas',

  components: {
      reserva,
  },

  data() {
    return {
        modulo: 'RESERVAS',

        cbAno: '2022',

        itemsRes: [],
        filterRes:[],
        itemsAno: [
            {id:'2022'},
        ],

    }
  },

  created() {
  },

  mounted() {
    if (!this.logueado) {
        this.$router.push('/');
        return;
    }
    //this.temp=this.itemsA[0].id;
    this.leemos();

  },

  computed: {
    ...mapState(['auth','SOL']),

    logueado() {
        return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },

  },

  methods: {
       ...mapMutations(['loading','alerta','modal']),
       ...mapActions(['exec']),

        async leemos() {

            var args={ token: this.auth.token, fnt:'get', adm: 0 }
            let r=await this.exec({api:'reservas0', arg: args });
            console.log('*reservas.leemos', r);

            if (r.error) {
                let m=r.datos;
                if (m=='Error Usuario (1)') {
                    m='La sesion iniciada se cerrará. Ha superado el tiempo de inactividad de su sesión.<br>Debe acceder de nuevo.';

                    this.$store.commit('login_off');
                    this.$router.push('/');
                    return;
                }

                m=(r.datos==''||r.datos==null?'NO HAY RESERVAS':r.datos);
                this.modal({tit: this.modulo, msg: m});

                this.$router.push('/inicio');
                return;
            }
            //guardamos datos
            this.itemsRes=Object.values(r.datos[0]);
            this.itemsAno=Object.values(r.datos[1]);

            this.cbAno=this.itemsAno[0].id;
            this.filtroReservas();
        },

        filtroReservas() {
            var E=this.itemsRes.slice();
            var EE=E;
            let a=Number(this.cbAno);
            //let s=Number(this.bStd);

            console.log('*filterReservas',a,E);

            /* if (t!='') EE=E.filter(e => {
                return (
                    e.exp.toLowerCase().includes(t)
                    ||e.ref.toLowerCase().includes(t)
                    ||e.contrato.toLowerCase().includes(t)
                    ||e.c1.toLowerCase().includes(t)
                    ||e.c2.toLowerCase().includes(t)
                );
            }); */

            if (a!='0') EE=E.filter(e => { return (a==e.ano) } );

            this.filterRes=EE;
        },


   }

}
</script>